import { call, put, takeLatest } from 'redux-saga/effects'
import {
  addSectorMemberSuccess,
  addSectorMemberFailed,
  ADD_SECTOR_MEMBER_START,
} from '../../actions/sector'
import { api } from '~/services/api/gameApi'

/**
 * add member sector pools api
 * @param {any} params Params will be sent to server
 * @returns {Promise}
 */
const addMemberSectorsApi = (props) => {
  var uri = `/api/game/sector/add-member`
  return api.post(uri, props)
}

/**
 * [Worker]
 * Handle get data request and response
 * @param {object} action
 */
function* doAddMemberSectors(action) {
  try {
    const response = yield call(addMemberSectorsApi, action?.payload)
    yield put(addSectorMemberSuccess(response))
    // Call callback action if provided
    if (action.onSuccess) {
      yield action.onSuccess(response)
    }
  } catch (error) {
    yield put(addSectorMemberFailed())
    // Call callback action if provided

    if (action.onError) {
      yield action.onError(error)
    }
  }
}

/**
 * [Watcher]
 * Watch add member sector pools
 */
export default function* watchAddMemberSector() {
  yield takeLatest(ADD_SECTOR_MEMBER_START, doAddMemberSectors)
}
